import { config as responsiveVideoConfig } from '../../templates/dynamic-content-page/content-components//video/responsive-video';
import { config as accordionConfig } from '../../templates/dynamic-content-page/content-components/accordion';
import { campaignConfig as buttonConfig } from '../../templates/dynamic-content-page/content-components/button';
import { config as claimTextConfig } from '../../templates/dynamic-content-page/content-components/claim-text';
import { config as claimWithContentConfig } from '../../templates/dynamic-content-page/content-components/claim-with-content/claim-with-content';
import { config as collectionSliderConfig } from '../../templates/dynamic-content-page/content-components/collections-slider/collection-slider';
import { config as contentSliderConfig } from '../../templates/dynamic-content-page/content-components/content-slider';
import { config as conversionTeaserConfig } from '../../templates/dynamic-content-page/content-components/conversion-teaser-variants';
import { campaignConfig as downloadConfig } from '../../templates/dynamic-content-page/content-components/download';
import { campaignConfig as flexibleContentConfig } from '../../templates/dynamic-content-page/content-components/flexible-content';
import { config as heading2Config } from '../../templates/dynamic-content-page/content-components/heading-2';
import { config as heroImageConfig } from '../../templates/dynamic-content-page/content-components/hero-image';
import { config as iconGridConfig } from '../../templates/dynamic-content-page/content-components/icon-grid';
import { config as imageSlideWithNumbersConfig } from '../../templates/dynamic-content-page/content-components/image-slide';
import { config as imageSlideshowConfig } from '../../templates/dynamic-content-page/content-components/image-slideshow';
import { config as imageWithTextOverlayConfig } from '../../templates/dynamic-content-page/content-components/image-with-text-overlay';
import { config as parallaxImageConfig } from '../../templates/dynamic-content-page/content-components/parallax-image';
import { config as personTileConfig } from '../../templates/dynamic-content-page/content-components/person-tile';
import { config as quoteSlideshowConfig } from '../../templates/dynamic-content-page/content-components/quote-slideshow';
import { config as sapFormConfig } from '../../templates/dynamic-content-page/content-components/sap-form';
import { config as sharedMewaCircleConfig } from '../../templates/dynamic-content-page/content-components/shared-mewa-circle';
import { config as shortTextTeaserConfig } from '../../templates/dynamic-content-page/content-components/short-text-teaser';
import { config as spacerConfig } from '../../templates/dynamic-content-page/content-components/spacer';
import { config as stickyNavigationSlideshowConfig } from '../../templates/dynamic-content-page/content-components/sticky-navigation-slideshow';
import { config as teaserWithImageConfig } from '../../templates/dynamic-content-page/content-components/teaser-with-image';
import {
  GenericConfig,
  getGenericSectionConfig,
} from '../../templates/dynamic-content-page/fragment-and-types';

export const possibleComponents: GenericConfig[] = [
  getGenericSectionConfig(accordionConfig),
  getGenericSectionConfig(buttonConfig),
  getGenericSectionConfig(claimTextConfig),
  getGenericSectionConfig(claimWithContentConfig),
  getGenericSectionConfig(collectionSliderConfig),
  getGenericSectionConfig(contentSliderConfig),
  getGenericSectionConfig(conversionTeaserConfig),
  getGenericSectionConfig(downloadConfig),
  getGenericSectionConfig(flexibleContentConfig),
  getGenericSectionConfig(heading2Config),
  getGenericSectionConfig(heroImageConfig),
  getGenericSectionConfig(iconGridConfig),
  getGenericSectionConfig(imageSlideWithNumbersConfig),
  getGenericSectionConfig(imageSlideshowConfig),
  getGenericSectionConfig(imageWithTextOverlayConfig),
  getGenericSectionConfig(parallaxImageConfig),
  getGenericSectionConfig(personTileConfig),
  getGenericSectionConfig(quoteSlideshowConfig),
  getGenericSectionConfig(responsiveVideoConfig),
  getGenericSectionConfig(sapFormConfig),
  getGenericSectionConfig(sharedMewaCircleConfig),
  getGenericSectionConfig(spacerConfig),
  getGenericSectionConfig(stickyNavigationSlideshowConfig),
  getGenericSectionConfig(teaserWithImageConfig),
  getGenericSectionConfig(shortTextTeaserConfig),
];
